const keys = {
  aanentoistossa_tapahtui_virhe: {
    eng: "An error occurred while playing audio",
    fin: "Äänentoistossa tapahtui virhe",
    sme: "",
    smn: "",
    sms: "",
    swe: "Ett fel inträffade vid uppspelning av ljud"
  },

  aani: {
    eng: "Audio",
    fin: "Ääni",
    sme: "",
    smn: "",
    sms: "",
    swe: "Ljud"
  },

  aani_tekstitykset: {
    eng: "Audio / Subtitles",
    fin: "Ääni / Tekstitykset",
    sme: "",
    smn: "",
    sms: "",
    swe: "Ljud / Textningar"
  },

  aaniraita: {
    eng: "Audiotrack",
    fin: "Ääniraita",
    sme: "",
    smn: "",
    sms: "",
    swe: "Ljudspår"
  },

  ala_ohjaa_seuraavaan_jaksoon: {
    eng: "Do not show the next episode",
    fin: "Älä ohjaa seuraavaan jaksoon",
    sme: "",
    smn: "",
    sms: "",
    swe: "Gå inte vidare till nästa avsnitt"
  },

  aloita: {
    eng: "Begin",
    fin: "Aloita",
    sme: "",
    smn: "",
    sms: "",
    swe: "Börja"
  },

  aloita_alusta: {
    fin: "Aloita alusta",
    sme: "",
    smn: "",
    sms: "",
    swe: "Börja från början"
  },

  areenaSimulcastUrl: {
    fin: `${__AREENA_URL}/suorat`,
    sme: `${__AREENA_URL}/suorat`,
    smn: `${__AREENA_URL}/suorat`,
    sms: `${__AREENA_URL}/suorat`,
    swe: `${__ARENAN_URL}/direkt`
  },

  areenaUrl: {
    eng: __AREENA_URL,
    fin: __AREENA_URL,
    sme: __AREENA_URL,
    smn: __AREENA_URL,
    sms: __AREENA_URL,
    swe: __ARENAN_URL
  },

  aseta: {
    eng: "Use",
    fin: "Käytä",
    sme: "",
    smn: "",
    sms: "",
    swe: "Använd"
  },

  aseta_tekstityksen_koko: {
    eng: "Set subtitles size",
    fin: "Aseta tekstityksen koko",
    sme: "",
    smn: "",
    sms: "",
    swe: "Ange textstorleken"
  },

  asetukset: {
    eng: "Settings",
    fin: "Asetukset",
    sme: "",
    smn: "",
    sms: "",
    swe: "Inställningar"
  },

  automatic: {
    eng: "Automatic",
    fin: "Automaattinen",
    sme: "",
    smn: "",
    sms: "",
    swe: "Automatisk"
  },

  avaa_chat: {
    eng: "Open chat",
    fin: "Avaa chat",
    sme: "",
    smn: "",
    sms: "",
    swe: "Öppna chatten"
  },

  buffer_progress: {
    eng: "Buffer progress",
    fin: "Puskuroinnin edistyminen",
    sme: "",
    smn: "",
    sms: "",
    swe: "Buffringens framskridning"
  },

  content_rating_age_restriction_0: {
    eng: "For all ages",
    fin: "Sallittu kaikenikäisille",
    sme: "",
    smn: "",
    sms: "",
    swe: "Tillåtet för alla åldrar"
  },

  content_rating_age_restriction_12: {
    eng: "Not for persons under 12",
    fin: "Sallittu yli 12-vuotiaille",
    sme: "",
    smn: "",
    sms: "",
    swe: "Förbjudet under 12 år"
  },

  content_rating_age_restriction_16: {
    eng: "Not for persons under 16",
    fin: "Sallittu yli 16-vuotiaille",
    sme: "",
    smn: "",
    sms: "",
    swe: "Förbjudet under 16 år"
  },

  content_rating_age_restriction_18: {
    eng: "Not for persons under 18",
    fin: "Sallittu yli 18-vuotiaille",
    sme: "",
    smn: "",
    sms: "",
    swe: "Förbjudet under 18 år"
  },

  content_rating_age_restriction_7: {
    eng: "Not for persons under 7",
    fin: "Sallittu yli 7-vuotiaille",
    sme: "",
    smn: "",
    sms: "",
    swe: "Förbjudet under 7 år"
  },

  content_rating_anxiety: {
    eng: "May cause anxiety",
    fin: "Voi aiheuttaa ahdistusta",
    sme: "",
    smn: "",
    sms: "",
    swe: "Kan skapa ångest"
  },

  content_rating_drugs_intoxicants: {
    eng: "Contains drug use",
    fin: "Sisältää päihteidenkäyttöä",
    sme: "",
    smn: "",
    sms: "",
    swe: "Användning av rusmedel"
  },

  content_rating_sex: {
    eng: "Sexual content",
    fin: "Sisältää seksiä",
    sme: "",
    smn: "",
    sms: "",
    swe: "Sexuellt innehåll"
  },

  content_rating_violence: {
    eng: "Contains violence",
    fin: "Sisältää väkivaltaa",
    sme: "",
    smn: "",
    sms: "",
    swe: "Våldsinslag"
  },

  copy_link: {
    eng: "Copy link",
    fin: "Kopioi linkki",
    sme: "",
    smn: "",
    sms: "",
    swe: "Kopiera länken"
  },

  ei_voi_toistaa: {
    eng: "Oh, something went wrong. Content could not be played.",
    fin: "Hups, jokin meni pieleen. Sisältöä ei voitu toistaa.",
    sme: "",
    smn: "",
    sms: "",
    swe: "Oj nåt gick fel. Innehållet kunde inte spelas upp."
  },

  email: {
    eng: "Email",
    fin: "Sähköposti",
    sme: "",
    smn: "",
    sms: "",
    swe: "E-post"
  },

  huomenna: {
    eng: "tomorrow",
    fin: "huomenna",
    sme: "ihtin",
    smn: "itten",
    sms: "jâđđa",
    swe: "imorgon"
  },

  jaa_kohdasta: {
    eng: "Share from",
    fin: "Jaa kohdasta",
    sme: "",
    smn: "",
    sms: "",
    swe: "Dela från"
  },

  jaa_ohjelma: {
    eng: "Share program",
    fin: "Jaa ohjelma",
    sme: "",
    smn: "",
    sms: "",
    swe: "Dela programmet"
  },

  jakso: {
    eng: "Episode",
    fin: "Jakso",
    sme: "",
    smn: "",
    sms: "",
    swe: "Avsnitt"
  },

  jaljella: {
    eng: "left",
    fin: "jäljellä",
    sme: "",
    smn: "",
    sms: "",
    swe: "återstår"
  },

  jatka: {
    eng: "Continue",
    fin: "Jatka",
    sme: "Joatkke",
    smn: "Juáđhi",
    sms: "Jueʹtǩ",
    swe: "Fortsätt"
  },

  // jatka_kuuntelua: {
  //   eng: "Continue to listen",
  //   fin: "Jatka kuuntelua",
  //   sme: "Joatkke guldaleami",
  //   smn: "Juáđhi kuldâlem",
  //   sms: "Jueʹtǩ kulddlummuž",
  //   swe: "Fortsätt lyssna"
  // },

  // julkaistu: {
  //   eng: "Published",
  //   fin: "Julkaistu",
  //   sme: "Almmustahttojuvvon",
  //   smn: "Almostittum",
  //   sms: "Õlmstõttum",
  //   swe: "Publicerad"
  // },

  katkaise_yhteys: {
    eng: "Disconnect the connection",
    fin: "Katkaise yhteys",
    sme: "",
    smn: "",
    sms: "",
    swe: "Avbryt kopplingen"
  },

  katso_eun_alueella: {
    eng: "Watch in EU",
    fin: "Katso EU:n alueella",
    sme: "",
    smn: "",
    sms: "",
    swe: "Titta inom EU-området"
  },

  katso_seuraavaksi: {
    eng: "Also watch",
    fin: "Katso seuraavaksi",
    sme: "",
    smn: "",
    sms: "",
    swe: "Titta också på"
  },

  katso_yle_areenassa: {
    eng: "Watch in Yle Areena",
    fin: "Katso Yle Areenassa",
    sme: "Geahča Yle Areenas",
    smn: "Keejâ Yle areenast",
    sms: "Ǩiõčč Yle Areenast",
    swe: "Se på Yle Arenan"
  },

  kausi_jakso_lyhyt: {
    eng: "S%(season), E%(episode)",
    fin: "K%(season), J%(episode)",
    sme: "",
    smn: "",
    sms: "",
    swe: "S%(season), A%(episode)"
  },

  kausi_jakso_pitka: {
    eng: "Season %(season), episode %(episode)",
    fin: "Kausi %(season), jakso %(episode)",
    sme: "",
    smn: "",
    sms: "",
    swe: "Säsong %(season), avsnitt %(episode)"
  },

  kelaa_10s_eteenpain: {
    eng: "Fast forward 10 seconds",
    fin: "Kelaa 10 sekuntia eteenpäin",
    sme: "",
    smn: "",
    sms: "",
    swe: "Spola framåt 10 sekunder"
  },

  kelaa_10s_taaksepain: {
    eng: "Rewind 10 seconds",
    fin: "Kelaa 10 sekuntia taaksepäin",
    sme: "",
    smn: "",
    sms: "",
    swe: "Spola bakåt 10 sekunder"
  },

  keskeyta: {
    eng: "Pause",
    fin: "Keskeytä",
    sme: "",
    smn: "",
    sms: "",
    swe: "Paus"
  },

  keskeyta_aria_label: {
    eng: "Pause - shortcut k",
    fin: "Keskeytä - pikanäppäin k",
    sme: "",
    smn: "",
    sms: "",
    swe: "Paus - kortkommando k"
  },

  keskeyta_pikanap: {
    eng: "Pause (k)",
    fin: "Keskeytä (k)",
    sme: "",
    smn: "",
    sms: "",
    swe: "Paus (k)"
  },

  klo: {
    eng: "time",
    fin: "klo",
    sme: "dii.",
    smn: "tme",
    sms: "čiâss",
    swe: "kl."
  },

  koko_naytto: {
    eng: "Full screen (f)",
    fin: "Koko näyttö (f)",
    sme: "",
    smn: "",
    sms: "",
    swe: "Helskärm (f)"
  },

  koko_naytto_aria_label: {
    eng: "Full screen - shortcut f",
    fin: "Koko näyttö - pikanäppäin f",
    sme: "",
    smn: "",
    sms: "",
    swe: "Helskärm - kortkommando f"
  },

  kopioi_ohjelmasivun_linkki: {
    eng: "Copy link to program page",
    fin: "Kopioi ohjelmasivun linkki",
    sme: "",
    smn: "",
    sms: "",
    swe: "Kopiera länken till programsidan"
  },

  kopioi_upotuskoodi: {
    eng: "Copy embed code",
    fin: "Kopioi upotuskoodi",
    sme: "",
    smn: "",
    sms: "",
    swe: "Kopiera inbäddningskoden"
  },

  kopioitu_leikepoydalle: {
    eng: "Copied to clipboard",
    fin: "Kopioitu leikepöydälle",
    sme: "",
    smn: "",
    sms: "",
    swe: "Kopierad till urklipp"
  },

  kulunut: {
    eng: "elapsed",
    fin: "kulunut",
    sme: "",
    smn: "",
    sms: "",
    swe: "spelat"
  },

  kuunneltavissa: {
    eng: "Listenable",
    fin: "Kuunneltavissa",
    sme: "",
    smn: "",
    sms: "",
    swe: "Går att lyssna på"
  },

  kuuntele: {
    eng: "Listen",
    fin: "Kuuntele",
    sme: "Guldal",
    smn: "Kuldâl",
    sms: "Kulddâl",
    swe: "Lyssna"
  },

  kuuntele_eun_alueella: {
    eng: "Listen in EU",
    fin: "Kuuntele EU:n alueella",
    sme: "",
    smn: "",
    sms: "",
    swe: "Lyssna inom EU-området"
  },

  kuuntele_juttu: {
    eng: "Listen",
    fin: "Kuuntele juttu",
    sme: "Guldal",
    smn: "Kuldâl",
    sms: "Kulddâl",
    swe: "Lyssna (du hör en artificiell röst)"
  },

  kuuntele_lahetysta: {
    eng: "Listen to live broadcast",
    fin: "Kuuntele live-lähetystä",
    sme: "Guldal vuolggahusa",
    smn: "Kuldâl vuolgâttâs",
    sms: "Kulddâl vuõlttõõzz",
    swe: "Lyssna på direktsändningen"
  },

  kuuntele_yle_areenassa: {
    eng: "Listen in Yle Areena",
    fin: "Kuuntele Yle Areenassa",
    sme: "Guldal Yle Areenas",
    smn: "Kuldâl Yle areenast",
    sms: "Kulddâl Yle Areenast",
    swe: "Lyssna på Yle Arenan"
  },

  kuva_kuvassa: {
    eng: "Picture in picture (i)",
    fin: "Kuva kuvassa (i)",
    sme: "",
    smn: "",
    sms: "",
    swe: "Bild i bild (i)"
  },

  kuva_kuvassa_aria_label: {
    eng: "Picture in picture - shortcut i",
    fin: "Kuva kuvassa - pikanäppäin i",
    sme: "",
    smn: "",
    sms: "",
    swe: "Bild i bild - kortkommando i"
  },

  laatu: {
    eng: "Quality",
    fin: "Laatu",
    sme: "",
    smn: "",
    sms: "",
    swe: "Kvalitet"
  },

  // lahetys_alkaa: {
  //   eng: "Broadcast starts",
  //   fin: "Lähetys alkaa",
  //   sme: "Vuolggahus álgá",
  //   smn: "Vuolgâttâs álgá",
  //   sms: "Vuõlttõs älgg",
  //   swe: "Sändningen börjar"
  // },

  linkki: {
    eng: "Link",
    fin: "Linkki",
    sme: "",
    smn: "",
    sms: "",
    swe: "Länk"
  },

  linkki_yle_areenaan: {
    eng: "Link to Yle Areena",
    fin: "Linkki Yle Areenaan",
    sme: "",
    smn: "",
    sms: "",
    swe: "Länk till Yle Arenan"
  },

  lisaa_omiin_suosikkeihisi_ja_katso_myohemmin: {
    eng: "Add to favorites and watch later",
    fin: "Lisää omiin suosikkeihisi ja katso myöhemmin",
    sme: "",
    smn: "",
    sms: "",
    swe: "Lägg till dina egna favoriter och titta senare"
  },

  minuuttia: {
    eng: "minutes",
    fin: "minuuttia",
    sme: "",
    smn: "",
    sms: "",
    swe: "minuter"
  },

  muokattu_tekstityksen_koko: {
    eng: "Custom subtitles size",
    fin: "Muokattu tekstityksen koko",
    sme: "",
    smn: "",
    sms: "",
    swe: "Redigerad textstorlek"
  },

  muokkaa_tekstityksen_kokoa: {
    eng: "Edit subtitles size",
    fin: "Muokkaa tekstityksen kokoa",
    sme: "",
    smn: "",
    sms: "",
    swe: "Redigera textstorleken"
  },

  mykista: {
    eng: "Mute (m)",
    fin: "Mykistä (m)",
    sme: "",
    smn: "",
    sms: "",
    swe: "Ljud av (m)"
  },

  mykista_aria_label: {
    eng: "Mute - shortcut m",
    fin: "Mykistä - pikanäppäin m",
    sme: "",
    smn: "",
    sms: "",
    swe: "Ljud av - kortkommando m"
  },

  nayta_ohjelma: {
    eng: "Show the program",
    fin: "Näytä ohjelma",
    sme: "",
    smn: "",
    sms: "",
    swe: "Visa programmet"
  },

  nayta_ohjelman_kuvaus: {
    eng: "Show description for program",
    fin: "Näytä ohjelman kuvaus",
    sme: "",
    smn: "",
    sms: "",
    swe: "Visa programmets beskrivning"
  },

  nopeus: {
    eng: "Speed",
    fin: "Nopeus",
    sme: "",
    smn: "",
    sms: "",
    swe: "Hastighet"
  },

  normaalinopeus: {
    eng: "Normal",
    fin: "Normaali",
    sme: "",
    smn: "",
    sms: "",
    swe: "Normal"
  },

  ohita_intro: {
    eng: "Skip intro",
    fin: "Ohita intro",
    sme: "",
    smn: "",
    sms: "",
    swe: "Hoppa över intro"
  },

  ohita_lopputekstit: {
    eng: "Skip credits",
    fin: "Ohita lopputekstit",
    sme: "",
    smn: "",
    sms: "",
    swe: "Hoppa över eftertexter"
  },

  ohjelma_alkaa_xx_min_xx_s_kuluttua: {
    eng: "Program starts in %(minutes) minutes and %(seconds) seconds",
    fin: "Ohjelma alkaa %(minutes) minuutin %(seconds) sekunnin kuluttua",
    sme: "Prográmma álgá %(minutes) minuhta %(seconds) sekundda geahčen",
    smn: "Ohjelm álgá %(minutes) miinut %(seconds) seekunt keččin",
    sms: "Programm älgg %(minutes) minuutt %(seconds) sekuund ǩeeʹjjest",
    swe: "Programmet börjar om %(minutes) minuter och %(seconds) sekunder"
  },

  ohjelma_alkaa_xx_s_kuluttua: {
    eng: "Program starts in %(seconds) seconds",
    fin: "Ohjelma alkaa %(seconds) sekunnin kuluttua",
    sme: "Prográmma álgá %(seconds) sekundda geahčen",
    smn: "Ohjelm álgá %(seconds) seekunt keččin",
    sms: "Programm älgg %(seconds) sekuund ǩeeʹjjest",
    swe: "Programmet börjar om %(seconds) sekunder"
  },

  ohjelma_ei_ole_enaa_kuunneltavissa: {
    eng: "Program no longer available",
    fin: "Ohjelma ei ole enää kuunneltavissa",
    sme: "Prográmma ii leat šat gullan láhkai",
    smn: "Ohjelm ij lah innig kuullâmnáálá",
    sms: "Programm iʹlla teänab kuullâmnalla",
    swe: "Programmet är inte längre tillgängligt"
  },

  ohjelma_ei_ole_katsottavissa_ulkomailla: {
    eng: "Program not available abroad",
    fin: "Ohjelma ei ole katsottavissa ulkomailla",
    sme: "Prográmma ii leat geahččan láhkai olgoriikkain",
    smn: "Ohjelm ij lah keččâmnáálá olgoenâmijn",
    sms: "Prograamm ij vueiʹt ǩiõččâd ålggjânnmin",
    swe: "Det går inte att se programmet utomlands"
  },

  // ohjelma_ei_ole_kuunneltavissa_lahetyksen_jalkeen: {
  //   eng: "Program not available after broadcast",
  //   fin: "Ohjelma ei ole kuunneltavissa lähetyksen jälkeen",
  //   sme: "Prográmma ii leat gullan láhkai vuolggahusa maŋŋá",
  //   smn: "Ohjelm ij lah kuullâmnáálá vuolgâttâs maŋa",
  //   sms: "Prograamm ij vueiʹt kulddled vuõlttõõzz mâŋŋa",
  //   swe: "Programmet är inte tillgängligt efter sändning"
  // },

  ohjelma_ei_ole_kuunneltavissa_ulkomailla: {
    eng: "The program cannot be listened to abroad",
    fin: "Ohjelma ei ole kuunneltavissa ulkomailla",
    sme: "",
    smn: "",
    sms: "",
    swe: "Programmet går inte att lyssna på utomlands"
  },

  ohjelma_on_katsottavissa_vain_suorana: {
    eng: "Only available live",
    fin: "Ohjelma on katsottavissa vain suorana",
    sme: "Prográmma lea geahččan láhkai dušše njuolggo vuolggahussan",
    smn: "Ohjelm lii keččâmnáálá tuše njuolgâvuolgâttâsân",
    sms: "Prograamm vuäitt ǩiõččâd pâi vuõiggvuõlttõssân",
    swe: "Går endast att se i direktsändning"
  },

  // ohjelma_on_kuunneltavissa_lahetyksen_jalkeen: {
  //   eng: "Program available after broadcast",
  //   fin: "Ohjelma on kuunneltavissa lähetyksen jälkeen",
  //   sme: "Prográmma lea gullan láhkai vuolggahusa maŋŋá",
  //   smn: "Ohjelm lii kuullâmnáálá vuolgâttâs maŋa",
  //   sms: "Programm lij kuullâmnalla vuõlttõõzz mâŋŋa",
  //   swe: "Lyssna på sändningen efter"
  // },

  ohjelma_on_tulossa_katsottavaksi: {
    eng: "Program will be available soon",
    fin: "Ohjelma on tulossa katsottavaksi",
    sme: "Prográmma lea boahtimin geahččan láhkai",
    smn: "Ohjelm lii puátimin keččâmnáálá",
    sms: "Programm lij pueʹttmen ǩiõččâmnalla",
    swe: "Programmet är tillgängligt"
  },

  // ohjelma_on_tulossa_kuunneltavaksi: {
  //   eng: "Program will soon be available",
  //   fin: "Ohjelma on tulossa kuunneltavaksi",
  //   sme: "Prográmma lea boahtimin gullan láhkai",
  //   smn: "Ohjelm lii puátimin kuullâmnáálá",
  //   sms: "Programm lij pueʹttmen kuullâmnalla",
  //   swe: "Programmet är tillgängligt"
  // },

  ohjelman_katseluaika_on_paattynyt: {
    eng: "Program no longer available",
    fin: "Ohjelman katseluaika on päättynyt",
    sme: "Prográmma geahččanáigi lea nohkan",
    smn: "Ohjelm keččâmäigi lii nuuhâm",
    sms: "Prograamm ǩiõččamäiʹǧǧ lij puuttâm",
    swe: "Programmets visningstid på nätet har utgått"
  },

  oletuskoko: {
    eng: "Standard size",
    fin: "Oletuskoko",
    sme: "",
    smn: "",
    sms: "",
    swe: "Standardstorlek"
  },

  palaa_edelliseen_valikkoon: {
    eng: "Back to previous menu",
    fin: "Palaa edelliseen valikkoon",
    sme: "",
    smn: "",
    sms: "",
    swe: "Tillbaka till föregående meny"
  },

  pois: {
    eng: "Off",
    fin: "Pois",
    sme: "",
    smn: "",
    sms: "",
    swe: "Av"
  },

  poista_mykistys: {
    eng: "Unmute (m)",
    fin: "Poista mykistys (m)",
    sme: "",
    smn: "",
    sms: "",
    swe: "Ljud på (m)"
  },

  poista_mykistys_aria_label: {
    eng: "Unmute - shortcut m",
    fin: "Poista mykistys - pikanäppäin m",
    sme: "",
    smn: "",
    sms: "",
    swe: "Ljud på - kortkommando m"
  },

  poistu_koko_nayton_tilasta: {
    eng: "Exit full screen (f)",
    fin: "Poistu koko näytön tilasta (f)",
    sme: "",
    smn: "",
    sms: "",
    swe: "Avsluta helskärmsläge (f)"
  },

  poistu_koko_nayton_tilasta_aria_label: {
    eng: "Exit full screen - shortcut f",
    fin: "Poistu koko näytön tilasta - pikanäppäin f",
    sme: "",
    smn: "",
    sms: "",
    swe: "Avsluta helskärmsläge - kortkommando f"
  },

  poistuu: {
    eng: "Will become unavailable",
    fin: "Poistuu",
    sme: "Jávká",
    smn: "jávkkán",
    sms: "Uiddal",
    swe: "Avpubliceras"
  },

  preview_image: {
    eng: "Preview image",
    fin: "Esikatselukuva",
    sme: "",
    smn: "",
    sms: "",
    swe: "Previewbild"
  },

  seek_slider: {
    eng: "Seek slider",
    fin: "Aikajana",
    sme: "",
    smn: "",
    sms: "",
    swe: "Tidslinje"
  },

  sekuntia: {
    eng: "seconds",
    fin: "sekuntia",
    sme: "",
    smn: "",
    sms: "",
    swe: "sekunder"
  },

  seuraava_alkaa_xx_s_kuluttua: {
    eng: "Next starts in %(seconds) seconds",
    fin: "Seuraava alkaa %(seconds) s. kuluttua",
    sme: "Čuovvovaš álgá %(seconds) sekundda geahčen",
    smn: "Čuávuvâš álgá %(seconds) s. keččin",
    sms: "Nuʹbb älgg %(seconds) s. ǩeeʹjjest",
    swe: "Nästa börjar om %(seconds) s."
  },

  seuraava_jakso: {
    eng: "Next episode",
    fin: "Seuraava jakso",
    sme: "",
    smn: "",
    sms: "",
    swe: "Nästa avsnitt"
  },

  share_audio: {
    eng: "Share audio",
    fin: "Jaa audio",
    sme: "",
    smn: "",
    sms: "",
    swe: "Dela audio"
  },

  sulje_aani_tekstitykset: {
    eng: "Close audio / subtitles",
    fin: "Sulje ääni / tekstitykset",
    sme: "",
    smn: "",
    sms: "",
    swe: "Stäng ljud / textningar"
  },

  sulje_asetukset: {
    eng: "Close settings",
    fin: "Sulje asetukset",
    sme: "",
    smn: "",
    sms: "",
    swe: "Stäng inställningar"
  },

  sulje_ohjelman_kuvaus: {
    eng: "Close description for program",
    fin: "Sulje ohjelman kuvaus",
    sme: "",
    smn: "",
    sms: "",
    swe: "Stäng programmets beskrivning"
  },

  sulje_ohjelmanjakonäkymä: {
    eng: "Close sharing view",
    fin: "Sulje jakonäkymä",
    sme: "",
    smn: "",
    sms: "",
    swe: "Stäng delningsvyn"
  },

  sulje_suosittelulistaus: {
    eng: "Close recommendations list",
    fin: "Sulje suosittelulistaus",
    sme: "",
    smn: "",
    sms: "",
    swe: "Stäng rekommendationslistningen"
  },

  suora: {
    eng: "LIVE",
    fin: "SUORA",
    sme: "",
    smn: "",
    sms: "",
    swe: "LIVE"
  },

  suoraa_lahetysta_jaljessa: {
    eng: "Behind the live broadcast",
    fin: "Suoraa lähetystä jäljessä",
    sme: "",
    smn: "",
    sms: "",
    swe: "Fördröjd från direktsändningen"
  },

  takaisin: {
    eng: "Back",
    fin: "Takaisin",
    sme: "",
    smn: "",
    sms: "",
    swe: "Tillbaka"
  },

  tanaan: {
    eng: "today",
    fin: "tänään",
    sme: "odne",
    smn: "onne",
    sms: "täʹbbe",
    swe: "idag"
  },

  tekstityksen_esimerkkikoko: {
    fin: "Tekstityksen esimerkkikoko",
    sme: "",
    smn: "",
    sms: "",
    swe: "Exempel på textstorleken"
  },

  tekstitykset: {
    eng: "Subtitles",
    fin: "Tekstitykset",
    sme: "",
    smn: "",
    sms: "",
    swe: "Textning"
  },

  tekstityksien_koko: {
    eng: "Subtitles size",
    fin: "Tekstityksen koko",
    sme: "",
    smn: "",
    sms: "",
    swe: "Textstorleken"
  },
  tekstityksien_taustavari: {
    eng: "Background",
    fin: "Taustaväri",
    sme: "",
    smn: "",
    sms: "",
    swe: "Bakgrundsfärg"
  },
  tekstityksien_taustavari_black: {
    eng: "Black",
    fin: "Musta",
    sme: "",
    smn: "",
    sms: "",
    swe: "Svart"
  },
  tekstityksien_taustavari_none: {
    eng: "No background",
    fin: "Ei taustaa",
    sme: "",
    smn: "",
    sms: "",
    swe: "Ingen bakgrund"
  },
  tekstityksien_taustavari_white: {
    eng: "White",
    fin: "Valkoinen",
    sme: "",
    smn: "",
    sms: "",
    swe: "Vit"
  },
  tekstitys_asetukset: {
    eng: "Subtitles settings",
    fin: "Tekstityksen asetukset",
    sme: "",
    smn: "",
    sms: "",
    swe: "Textningsinställningar"
  },

  timer_completed: {
    eng: "Downloading media",
    fin: "Ladataan mediaa",
    swe: "Laddar media"
    // sme: "",
    // sms: "",
    // smn: ""
  },

  timer_failed: {
    eng: "Could not download media. Try to refresh the page",
    fin: "Mediaa ei saatu ladattua. Yritä ladata sivu uudelleen",
    swe: "Lyckades inte ladda ner media. Försök ladda om sidan"
    // sme: "",
    // sms: "",
    // smn: ""
  },

  timer_program_starts_soon: {
    eng: "The program will start soon",
    fin: "Ohjelma alkaa pian",
    swe: "Programmet startar snart"
  },

  timer_time_to_start: {
    eng: "until program starts",
    fin: "aikaa ohjelman alkuun",
    swe: "tills programmet börjar"
    // sme: "",
    // sms: "",
    // smn: ""
  },

  toista: {
    eng: "Play",
    fin: "Toista",
    sme: "",
    smn: "",
    sms: "",
    swe: "Spela upp"
  },

  toista_aria_label: {
    eng: "Play - shortcut k",
    fin: "Toista - pikanäppäin k",
    sme: "",
    smn: "",
    sms: "",
    swe: "Spela upp - kortkommando k"
  },

  toista_pikanap: {
    eng: "Play (k)",
    fin: "Toista (k)",
    sme: "",
    smn: "",
    sms: "",
    swe: "Spela upp (k)"
  },

  toista_tassa: {
    fin: "Toista tässä",
    sme: "",
    smn: "",
    sms: "",
    swe: "Spela här"
  },

  toista_tvssa: {
    eng: "Cast on the TV",
    fin: "Toista TV:ssä",
    sme: "",
    smn: "",
    sms: "",
    swe: "Casta på TV:n"
  },

  toista_uudelleen: {
    eng: "Replay",
    fin: "Toista uudelleen",
    sme: "",
    smn: "",
    sms: "",
    swe: "Spela igen"
  },

  toistetaan_laitteessa: {
    eng: "Casting to device",
    fin: "Toistetaan laitteessa",
    sme: "",
    smn: "",
    sms: "",
    swe: "Castar till enheten"
  },

  toistetaan_pip_tilassa: {
    fin: "Toistetaan kuva kuvassa -tilassa",
    sme: "",
    smn: "",
    sms: "",
    swe: "Programmet spelas upp i bild i bild-läge"
  },

  toistettavaa_mediaa_ei_loytynyt: {
    eng: "Media could not be found",
    fin: "Toistettavaa mediaa ei löytynyt",
    sme: "",
    smn: "",
    sms: "",
    swe: "Media kunde inte hittas"
  },

  toistonopeus: {
    eng: "Speed",
    fin: "Toistonopeus",
    sme: "",
    smn: "",
    sms: "",
    swe: "Hastighet"
  },

  tuntematon: {
    eng: "Unknown",
    fin: "Tuntematon",
    sme: "",
    smn: "",
    sms: "",
    swe: "Okänd"
  },

  tuntia: {
    eng: "hours",
    fin: "tuntia",
    sme: "",
    smn: "",
    sms: "",
    swe: "timmar"
  },

  upota: {
    eng: "Embed",
    fin: "Upota",
    sme: "",
    smn: "",
    sms: "",
    swe: "Bädda in"
  },

  valitse_koko: {
    eng: "Choose size",
    fin: "Valitse koko",
    sme: "",
    smn: "",
    sms: "",
    swe: "Välj storlek"
  },

  vapaavalintainen: {
    eng: "Custom",
    fin: "Vapaavalintainen",
    sme: "",
    smn: "",
    sms: "",
    swe: "Anpassad"
  },

  video_player: {
    eng: "Video player",
    fin: "Videosoitin",
    sme: "",
    smn: "",
    sms: "",
    swe: "Video player"
  },

  video_player_illustrational: {
    eng: "Illustrational video",
    fin: "Kuvitusvideo",
    sme: "",
    smn: "",
    sms: "",
    swe: "Illustrationsvideo"
  },

  volume: {
    eng: "Volume",
    fin: "Äänenvoimakkuus",
    sme: "",
    smn: "",
    sms: "",
    swe: "Ljudvolym"
  },

  vpn_estetty: {
    eng: "VPN blocked",
    fin: "VPN estetty",
    sme: "",
    smn: "",
    sms: "",
    swe: "VPN blockerad"
  },

  yhdistetaan: {
    eng: "Connecting...",
    fin: "Yhdistetään...",
    sme: "",
    smn: "",
    sms: "",
    swe: "Ansluter..."
  },

  yhdistetaan_laitteeseen: {
    eng: "Connecting to the device",
    fin: "Yhdistetään laitteeseen",
    sme: "",
    smn: "",
    sms: "",
    swe: "Ansluter till enheten"
  },

  yhdistetty_laitteeseen: {
    eng: "Connected to device",
    fin: "Yhdistetty laitteeseen",
    sme: "",
    smn: "",
    sms: "",
    swe: "Ansluten till enheten"
  },

  yrita_uudelleen: {
    eng: "Try again",
    fin: "Yritä uudelleen",
    sme: "",
    smn: "",
    sms: "",
    swe: "Försök på nytt"
  }
};

export type TranslationKey = keyof typeof keys;

export default (
  key: TranslationKey,
  options: { language?: string; s?: Record<string, unknown> }
): string => {
  const lang = options.language || "fin";
  const substitutions = options.s || [];
  let translation = keys[key][lang];
  Object.keys(substitutions).forEach(k => {
    const re = new RegExp("%\\(" + k + "\\)", "gm");
    translation = translation.replace(re, String(substitutions[k]));
  });
  return translation;
};
